import { render, staticRenderFns } from "./notice-occupation.vue?vue&type=template&id=24d62e3c&scoped=true&"
import script from "./notice-occupation.vue?vue&type=script&lang=js&"
export * from "./notice-occupation.vue?vue&type=script&lang=js&"
import style0 from "./notice-occupation.vue?vue&type=style&index=0&id=24d62e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d62e3c",
  null
  
)

export default component.exports